module.exports = __webpack_public_path__ + "img/icon_bms10.3dfc0e4a.jpg";